import { Component, signal, OnInit } from '@angular/core';
import { LoaderService } from '../services/loader.service';

@Component({
  standalone: false,
  selector: 'edportal-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent implements OnInit {
  isLoading = signal(false);
  constructor(private readonly loaderService: LoaderService) {}

  ngOnInit() {
    this.loaderService.loaderSignal$.subscribe((x) => this.isLoading.set(x));
  }
}
